import { render, staticRenderFns } from "./BeeAdvancedMoneyLabel.vue?vue&type=template&id=5ec6583e&"
import script from "./BeeAdvancedMoneyLabel.vue?vue&type=script&lang=js&"
export * from "./BeeAdvancedMoneyLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports